<template>
  <div class="border-b">
    <div class="px-4 py-4 sm:px-6">
      <div class="flex">
        <div class="mr-4 flex-shrink-0">
          <div class="h-16 w-16 overflow-hidden">
            <img v-bind:src="$route('product.image', item.sku)" class="object-cover pointer-events-none" alt />
          </div>
        </div>
        <div class="flex-grow">
          <div class="sm:flex sm:items-center sm:justify-between">
            <p class="md:truncate font-medium text-primary-600">{{ item.title }}</p>
          </div>
          <div class="mt-2 flex items-center space-x-3">
            <p class="flex items-center text-sm text-gray-500">
              <HashtagIcon class="mr-1 h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
              {{ item.sku }}
            </p>
            <p class="text-sm text-gray-500">QTY: {{ item.quantity }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { HashtagIcon } from "@heroicons/vue/20/solid";

const { item } = defineProps({
  item: {
    type: Object,
    required: true,
  }
})
</script>
